// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IUpdateAuthorizedUserDto
 */
export interface IUpdateAuthorizedUserDto {
    /**
     * 
     * @type {string}
     * @memberof IUpdateAuthorizedUserDto
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof IUpdateAuthorizedUserDto
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof IUpdateAuthorizedUserDto
     */
    relationship_type: IUpdateAuthorizedUserDtoRelationshipTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IUpdateAuthorizedUserDto
     */
    birth_on: Date;
}

/**
* @export
* @enum {string}
*/
export enum IUpdateAuthorizedUserDtoRelationshipTypeEnum {
    SPOUSE = 'SPOUSE',
    CHILD = 'CHILD',
    DOMESTIC_PARTNER = 'DOMESTIC_PARTNER',
    OTHER = 'OTHER'
}


/**
 * Check if a given object implements the IUpdateAuthorizedUserDto interface.
 */
export function instanceOfIUpdateAuthorizedUserDto(value: object): value is IUpdateAuthorizedUserDto {
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('relationship_type' in value) || value['relationship_type'] === undefined) return false;
    if (!('birth_on' in value) || value['birth_on'] === undefined) return false;
    return true;
}

export function IUpdateAuthorizedUserDtoFromJSON(json: any): IUpdateAuthorizedUserDto {
    return IUpdateAuthorizedUserDtoFromJSONTyped(json, false);
}

export function IUpdateAuthorizedUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUpdateAuthorizedUserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'relationship_type': json['relationship_type'],
        'birth_on': (new Date(json['birth_on'])),
    };
}

export function IUpdateAuthorizedUserDtoToJSON(json: any): IUpdateAuthorizedUserDto {
    return IUpdateAuthorizedUserDtoToJSONTyped(json, false);
}

export function IUpdateAuthorizedUserDtoToJSONTyped(value?: IUpdateAuthorizedUserDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'relationship_type': value['relationship_type'],
        'birth_on': ((value['birth_on']).toISOString().substring(0,10)),
    };
}

